const StoreNotice = () =>{
    return (
      <aside className="store-notice">
      <div className="container">
         Due to the <strong>COVID 19</strong> epidemic, orders may be processed with a slight delay </div>
   </aside>
    );
}

export default StoreNotice;